module.exports = __webpack_public_path__ + "static/img/6.8296efb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/6.png
// module id = m6qg
// module chunks = 1